import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment'
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DoctorServiceService {
   backendUrl =`${environment.restAPIUrl}/api/public`
  //http://120.138.8.237:8080/
  //=http://localhost:8181/api/public/genders
  doctorRegistrationUrl = `${environment.restAPIUrl}/api/public/registration`;
  getGenderUrl=`${environment.restAPIUrl}/api/public/genders`;
  getCountryUrl=`${environment.restAPIUrl}/api/public/getCountry`;
  getStateUrl=`${environment.restAPIUrl}/api/public/getState`;
  getCityUrl=`${environment.restAPIUrl}/api/public/getCities`;
  getZipCodeUrl=``;
 language:any
  constructor(private http: HttpClient) { }
  getLanguagesList():Observable<object>{
    return this.http.get(`${this.backendUrl}/getLanguages`)
  }

  getGender(): Observable<any> {
    return this.http.get<any>(this.getGenderUrl);
  }
  getCountry(): Observable<any> {
    return this.http.get<any>(this.getCountryUrl);
  }
  getState(countryId: string): Observable<any> {
    return this.http.get<any>(this.getStateUrl + '?countryId=' + countryId);
  }
  getCity(stateId: string): Observable<any> {
    return this.http.get<any>(this.getCityUrl + '?stateId=' + stateId);
  }
  getZipCode(cityId: string): Observable<any> {
    return this.http.get<any>(this.getZipCodeUrl + '?cityId=' + cityId);
  }

  registerDoctor(registrationData: any): Observable<any> {
    return this.http.post<any>(this.doctorRegistrationUrl, registrationData, httpOptions);
  };

  getSpecilities():Observable<any>{
    return this.http.get<any>(`${this.backendUrl}/getSpecialities`)
  };

  uploadFiles(obj){
    return this.http.post<any>(`${this.backendUrl}/uploadCredentials`,obj)
  }
 
}
